export const encryptionKey='ENC45TY-09';